// converts "en-US" to { languageCode: "en", countryCode: "US" }
export default function parseLocaleString (localeString) {
  if (!localeString) return {};
  let parts = localeString.split('-');

  return {
    languageCode: parts[0].toLowerCase(),
    countryCode: (parts.length > 1)
      ? parts[1].toUpperCase()
      : '',
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/parseLocaleString.js